import type { FunctionComponent, PropsWithChildren, ReactNode } from 'react'

import styles from './legend.module.scss'
import { Heading } from '../../../components/heading'
import type { CustomFieldsetId } from '../../../graphql/hooks/form-page'

/** Fieldset title, <legend>-like */
export const Legend: FunctionComponent<Props> = ({
    children,
    customFieldsetId,
    preset = 'default',
}) => (
    <div className={styles.legend}>
        <Heading
            id={legendId(customFieldsetId)}
            level={preset === 'primary' ? 1 : 2}
            className={styles.heading}
        >
            {children}
        </Heading>
    </div>
)

export const SubLegend: FunctionComponent<PropsWithChildren<any>> = ({
    children,
}) => <div className={styles.sublegend}>{children}</div>

export const legendId = (customFieldsetId: CustomFieldsetId) =>
    `${customFieldsetId}.legend`

interface Props {
    /** Custom id of the parent fieldset. */
    customFieldsetId: CustomFieldsetId
    /** Determines if this the main section on page, affects markup semantics. */
    preset?: 'primary' | 'default'
    children?: ReactNode
}
